module.exports = __webpack_public_path__ + "img/62ne.bbc71a5d.svg";